export var normalizeLanguage = function (language) {
    switch (language) {
        case "pt":
            return "pt-br";
        default:
            return language;
    }
};
var ALLOWED_APP_LANGUAGES = ["en", "ru", "pt", "de", "es"];
export var normalizeAppLanguage = function (language, fallback) {
    if (fallback === void 0) { fallback = "en"; }
    if (!language)
        return fallback;
    var baseLanguage = language.split(/[-_]/)[0].toLowerCase();
    return ALLOWED_APP_LANGUAGES.includes(baseLanguage)
        ? baseLanguage
        : fallback;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm9ybWFsaXplTGFuZ3VhZ2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJub3JtYWxpemVMYW5ndWFnZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsSUFBTSxpQkFBaUIsR0FBRyxVQUFDLFFBQWdCO0lBQ2hELFFBQVEsUUFBUSxFQUFFO1FBQ2hCLEtBQUssSUFBSTtZQUNQLE9BQU8sT0FBTyxDQUFDO1FBQ2pCO1lBQ0UsT0FBTyxRQUFRLENBQUM7S0FDbkI7QUFDSCxDQUFDLENBQUE7QUFFRCxJQUFNLHFCQUFxQixHQUFHLENBQUMsSUFBSSxFQUFFLElBQUksRUFBRSxJQUFJLEVBQUUsSUFBSSxFQUFFLElBQUksQ0FBVSxDQUFDO0FBRXRFLE1BQU0sQ0FBQyxJQUFNLG9CQUFvQixHQUFHLFVBQ2xDLFFBQXdCLEVBQ3hCLFFBQXVEO0lBQXZELHlCQUFBLEVBQUEsZUFBdUQ7SUFFdkQsSUFBSSxDQUFDLFFBQVE7UUFBRSxPQUFPLFFBQVEsQ0FBQztJQUUvQixJQUFNLFlBQVksR0FBRyxRQUFRLENBQUMsS0FBSyxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLFdBQVcsRUFBRSxDQUFDO0lBRTdELE9BQU8scUJBQXFCLENBQUMsUUFBUSxDQUNuQyxZQUFzRCxDQUN2RDtRQUNDLENBQUMsQ0FBQyxZQUFZO1FBQ2QsQ0FBQyxDQUFDLFFBQVEsQ0FBQztBQUNmLENBQUMsQ0FBQyJ9